import './ccf-search-icon.module.scss';
import { SvgIcon , SvgIconProps} from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSearchIconProps extends SvgIconProps {}

/**
 * CcfSearchIcon used to disply search icon in the contact card history panel
 * @param props - CcfSearchIconProps
 * @example -- <CcfSearchIcon />
 */
export function CcfSearchIcon(props: CcfSearchIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_search_contact_history" clipPath="url(#clip-ic_search_contact_history)">
        <g id="Group_118949" data-name="Group 118949" transform="translate(-1 -1)" opacity="0.853">
          <rect id="Rectangle_37572" data-name="Rectangle 37572" width="32" height="32" transform="translate(-3 -3)" fill="#526B7A" opacity="0"/>
          <path id="Path_13879" data-name="Path 13879" d="M17.552,16.288l-4.836-4.836A7.144,7.144,0,0,0,7.075-.1,7.306,7.306,0,0,0,0,7.154a7.185,7.185,0,0,0,7.164,7.164A7.058,7.058,0,0,0,11.552,12.8l4.836,4.836a.866.866,0,0,0,1.254,0A1.075,1.075,0,0,0,17.552,16.288ZM7.164,12.437a5.373,5.373,0,1,1,5.373-5.373A5.389,5.389,0,0,1,7.164,12.437Z" transform="translate(4.363 4.1)" fill="#526B7A" opacity="1"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfSearchIcon;
